import PropTypes from 'prop-types';
import { Star, Award } from 'lucide-react';
import { Text } from '@/components/ui/index.js';
import styles from './HostCard.module.css';

/**
 * HostCard - Displays event host information
 * Shows avatar, name, rating, and events hosted count
 */
export function HostCard({ host, onViewProfile }) {
  const getInitials = (name) => {
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className={styles.hostCard}>
      <div className={styles.avatar}>
        {host.avatar ? (
          <img src={host.avatar} alt={host.name} className={styles.avatarImage} />
        ) : (
          <span className={styles.avatarInitials}>{getInitials(host.name)}</span>
        )}
      </div>

      <div className={styles.hostInfo}>
        <Text size="base" weight="semibold" color="primary" className={styles.hostName}>
          {host.name}
        </Text>

        <div className={styles.hostMeta}>
          <div className={styles.rating}>
            <Star size={14} className={styles.starIcon} />
            <Text size="sm" color="secondary">
              {host.rating}
            </Text>
          </div>

          <div className={styles.eventsHosted}>
            <Award size={14} className={styles.awardIcon} />
            <Text size="sm" color="secondary">
              {host.eventsHosted} events hosted
            </Text>
          </div>
        </div>
      </div>

      {onViewProfile && (
        <button
          className={styles.viewProfileButton}
          onClick={onViewProfile}
          aria-label={`View ${host.name}'s profile`}
        >
          <Text size="sm" color="cyan">
            View Profile
          </Text>
        </button>
      )}
    </div>
  );
}

HostCard.propTypes = {
  host: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    avatar: PropTypes.string,
    rating: PropTypes.number.isRequired,
    eventsHosted: PropTypes.number.isRequired,
  }).isRequired,
  onViewProfile: PropTypes.func,
};

export default HostCard;
